module.exports = "<a class=\"btn btn-success btn-modal-ok\"><%= translatedStrings['6fdd59e4-4837-4e98-bb80-9ca8337023ad'] %></a>";